module.exports = __webpack_public_path__ + "ipetbooking/admin/img/screen-users.a4a8a39c.svg";